import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { DialogData } from "../model/dialogData";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  dialog: BehaviorSubject<any> = new BehaviorSubject<any>('')

  constructor() { }

  setDialog(obj: DialogData) {
    this.dialog.next(obj)
  }

  getDialog() {
    return this.dialog
  }
}
